import { FC } from "react";
import {
  HEADED_SECTION_DEFAULTS,
  THeadedSectionProps,
} from "./HeadedSection.config";
import { Section } from "../../layout/Section";
import { HeadedSectionHeader } from "./HeadedSectionHeader";
import { HeadedSectionContent } from "./HeadedSectionContent";

export const HeadedSection: FC<THeadedSectionProps> = ({
  title,
  theme = HEADED_SECTION_DEFAULTS.theme,
  icon,
  children,
}) => (
  <Section data-component="HeadedSection">
    <HeadedSectionHeader title={title} theme={theme} icon={icon} />
    <HeadedSectionContent>
      { children }
    </HeadedSectionContent>
  </Section>
);
